import { useDispatch } from 'react-redux'
import actions from 'redux/action'

export default function useGlobalModal() {
  const dispatch = useDispatch()

  const openGlobalModal = (ChildrenComponent: any) => {
    dispatch(actions.openGlobalModal(ChildrenComponent))
  }

  const closeGlobalModal = () => {
    dispatch(actions.closeGlobalModal())
  }

  return {
    openGlobalModal,
    closeGlobalModal,
  }
}
